import { Flex } from '@blockanalitica/ui';
// @ts-ignore
import Logo from '@/assets/logos/BA-logo-full.svg?react';
// @ts-ignore
import SparkLogo from '@/assets/logos/sparklogotext.svg?react';
import { ExternalLink } from '@/components';
import { sparkUrl } from '@/utils';
import { DateTime } from 'luxon';

export default function Footer() {
  const currentYear = DateTime.now().year;
  return (
    <Flex
      as="footer"
      fontSize="-1"
      color="muted"
      padding="0 1"
      display="flex"
      flexDirection={['column', 'row']}
      justifyContent="space-between"
      alignItems="center"
      gap="s">
      <Flex gap="2xs" justifyContent="center" alignItems="center">
        <ExternalLink href={sparkUrl('https://spark.fi')}>
          <SparkLogo height={32} />
        </ExternalLink>
      </Flex>
      <Flex gap="2xs" justifyContent="center" alignItems="center">
        <Flex gap="2xs">
          <span>© {currentYear}</span>
          <span>|</span>
          <span>Made by</span>
        </Flex>

        <ExternalLink href="https://blockanalitica.com">
          <Logo height={32} />
        </ExternalLink>
        <span>|</span>

        <ExternalLink
          href="https://blockanalitica.com/terms-of-service/"
          color="muted">
          Terms of Service
        </ExternalLink>
      </Flex>
    </Flex>
  );
}
